import Component from "../../lib/component";
import navMenus from "../nav_menus/nav_menus";
import {injectStylesheet} from "../../helpers/injection";
import {Toggler} from './components/toggler';
import {Contents} from "./components/contents";
import {Body} from "./components/body";
import {Backdrop} from "./components/backdrop";
import {getThrottledFunction} from "../../helpers/throttle";
import {XHRFetcher} from "../../lib/xhr_fetcher";

export const NavMenuConfig = {
    componentTypeKey: 'NavMenu',
    baseHtmlClass: 'nav_menu',
    selector: '.nav_menu',

    datasetConfigKey: 'nav_menu__config',
    contentUrlDatasetConfigKey: 'content_url',
    sideDatasetConfigKey: 'side',
    styleSheetPathDatasetConfigKey: 'stylesheet_path',
    auxStyleSheetPathDatasetConfigKey: 'aux_stylesheet_path',
    hasPersonDatasetConfigKey: 'has_person',
    toggleImageDatasetConfigKey: 'toggle_image',

    modalWidthThreshold: 480, // The NavMenu is in 'modal' mode whenever the viewport is less than or equal to this threshold.
};

export class NavMenu extends Component {

    static get config() {
        return NavMenuConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: NavMenuConfig
        });

        this.navMenus = navMenus
        this.navMenus.add(this);

        // Get the configuration from the dataset…
        this.setDatasetConfig(NavMenu.config.datasetConfigKey);
        this.contentUrl = this.getDatasetConfigValue(NavMenu.config.contentUrlDatasetConfigKey);
        this.styleSheetPath = this.getDatasetConfigValue(NavMenu.config.styleSheetPathDatasetConfigKey);
        this.auxStyleSheetPath = this.getDatasetConfigValue(NavMenu.config.auxStyleSheetPathDatasetConfigKey);
        this.side = this.getDatasetConfigValue(NavMenu.config.sideDatasetConfigKey) ?? 'left';

        // General config…
        this.open = false;

        // sub components…
        this.toggler = Toggler.createToggler(this);
        this.contents = Contents.createContents(this);
        this.backdrop = Backdrop.createBackdrop(this);
        this.body = new Body(document.body, this);

        // Set up handlers…
        const resizeHandler = getThrottledFunction(this.handleResize.bind(this), 100);
        this.observer = new ResizeObserver(resizeHandler);
        this.observer.observe(this.body.element);

        // Render the initial state after we load any style sheets…
        if (this.styleSheetPath) {
            if (this.auxStyleSheetPath) {
                injectStylesheet(this.styleSheetPath, ()=>{
                    injectStylesheet(this.auxStyleSheetPath, this.renderInitial.bind(this));
                });
            } else {
                injectStylesheet(this.styleSheetPath, this.render.bind(this));
            }
        } else if (this.auxStyleSheetPath) {
            injectStylesheet(this.auxStyleSheetPath, this.renderInitial.bind(this));
        }
    };

    renderInitial() {
        new XHRFetcher(this.contentUrl).fetch().then((content) => {
            this.contents.setContent(content);
            // We don't want to see the animation on page load so after a short delay we remove the class to reveal the nav_menu.
            setTimeout(() => {
                this.element.style.display = null;
                this.backdrop.element.style.display = null;
                this.removeHtmlClassState('uninitialized');
                this.render();
            }, 300);
        });
    }

    handleResize() {
        this.render();
    };

    render() {
        this.swapHtmlClassStates(this.isOpen(), 'open', 'closed');
        this.renderModalState();
        this.renderSideState();

        this.toggler.render();
        this.contents.render();
        this.body.render();
        this.backdrop.render();

        if (this.isOpen()) this.navMenus.closeOthers(this);
    }

    renderSideState() {
        if (this.side === 'right') {
            this.addHtmlClassState('right');
        } else {
            this.removeHtmlClassState('right');
        }
        if (this.side === 'left') {
            this.addHtmlClassState('left');
        } else {
            this.removeHtmlClassState('left');
        }
    }

    renderModalState() {
        const isModal = (getViewportWidth() <= NavMenuConfig.modalWidthThreshold);
        this.conditionallySetHtmlClassState(isModal, 'modal')
    };

    toggle() {
        this.open = !this.open;
        this.render();
    }

    close() {
        this.open = false;
        this.render();
    };

    isOpen() {
        return !!this.open;
    }

}

function getViewportWidth() {
    let a = document.documentElement.clientWidth, b = window.innerWidth;
    return a < b ? b : a;
}
